import { Stack } from '@mui/material';
import styled from 'styled-components';

export const SyncTooltipContainer = styled(Stack)`
  && {
    cursor: pointer;
  }
`;
